import React from 'react';

interface Props {
  title: string;
}

const TitleLayout: React.FC<Props> = ({ title, children }) => (
  <div className="flex flex-col flex-grow overflow-auto h-5/6">
    <div className="my-3">
      <h1 className="ml-1 text-3xl font-semibold">{title}</h1>
    </div>
    {children}
  </div>
);

export default TitleLayout;
